// skillsData.js
import html from "../../assets/images/skills/1.png";
import css from "../../assets/images/skills/2.png";
import javascript from "../../assets/images/skills/3.png";
import react from "../../assets/images/skills/4.png";
import nextjs from "../../assets/images/skills/5.png";
import angular from "../../assets/images/skills/6.png";
import node from "../../assets/images/skills/7.png";
import nest from "../../assets/images/skills/8.png";
import express from "../../assets/images/skills/9.png";
import mongodb from "../../assets/images/skills/10.png";
import reactnative from "../../assets/images/skills/11.png";
import flutter from "../../assets/images/skills/12.png";

export const skillsData = [
  {
    name: "HTML",
    image: html,
  },
  {
    name: "CSS",
    image: css,
  },
  {
    name: "JavaScript",
    image: javascript,
  },
  {
    name: "React",
    image: react,
  },
  {
    name: "Next.js",
    image: nextjs,
  },
  {
    name: "Angular",
    image: angular,
  },
  {
    name: "Node.js",
    image: node,
  },
  {
    name: "NestJS",
    image: nest,
  },
  {
    name: "Express",
    image: express,
  },
  {
    name: "MongoDB",
    image: mongodb,
  },
  {
    name: "React Native",
    image: reactnative,
  },
  {
    name: "Flutter",
    image: flutter,
  },
];
